import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useTexts } from '../useTexts'
import { useControllerActions } from '../hooks/useControllerActions'
import { useController } from '../hooks/useController'

export function Footer() {
  const texts = useTexts()
  const actions = useControllerActions()
  const { status, invalid, close } = useController()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          onClick={actions.onConfirmTerritoryChange}
          disabled={invalid || status !== 'ready'}
          variant="contained"
          testid="modal-primary-button"
        >
          {texts.commandButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
